import React, { AnchorHTMLAttributes, FCWithChildren } from 'react';
import NextLink from 'next/link';

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  // If true will use Next.js Link instead of a standard <a> tag
  enableClientSideNavigation?: boolean;
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

const Link: FCWithChildren<LinkProps> = (props) => {
  const { href, onClick, enableClientSideNavigation = false, className, children, ...rest } = props;

  if (enableClientSideNavigation) {
    return (
      <NextLink
        href={href}
        className={className}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClick?.(e);
          }
        }}
        data-link-type="next"
        rel="noopener"
        tabIndex={0}
        {...rest}
      >
        {children}
      </NextLink>
    );
  }

  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClick?.(e);
        }
      }}
      data-link-type="native"
      rel="noopener"
      tabIndex={0}
      {...rest}
    >
      {children}
    </a>
  );
};

export default Link;
